<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.3322 19.4232C12.8102 19.6052 12.2402 19.3322 12.0572 18.8112C11.8732 18.2902 12.1482 17.7192 12.6682 17.5362C15.8572 16.4162 18.0002 13.3872 18.0002 10.0001C18.0002 6.61309 15.8572 3.58404 12.6682 2.46303C12.1472 2.28003 11.8732 1.70902 12.0572 1.18801C12.2022 0.77601 12.5872 0.519006 13.0002 0.519006C13.1102 0.519006 13.2222 0.538007 13.3322 0.576008C17.3202 1.97803 20.0003 5.76507 20.0003 10.0001C20.0003 14.2352 17.3202 18.0222 13.3322 19.4232Z"
        />
        <path
            d="M12.3982 6.79909C11.9572 6.46708 11.8692 5.84008 12.2012 5.39907C12.3972 5.13807 12.6972 5.00006 13.0012 5.00006C13.2102 5.00006 13.4212 5.06506 13.6022 5.20107C15.1042 6.33108 16.0002 8.1251 16.0002 10.0001C16.0002 11.8752 15.1042 13.6692 13.6022 14.7992C13.1592 15.1322 12.5332 15.0422 12.2022 14.6012C11.8701 14.1602 11.9582 13.5332 12.3992 13.2012C13.4012 12.4472 14.0002 11.2501 14.0002 10.0001C14.0002 8.75011 13.4012 7.5531 12.3982 6.79909Z"
        />
        <path
            d="M10.3831 19.9243C10.0081 20.0783 9.57912 19.9933 9.29312 19.7073L4.58606 15.0002H2.00003C0.897011 15.0002 0 14.1032 0 13.0002V7.00009C0 5.89708 0.897011 5.00006 2.00003 5.00006H4.58606L9.29312 0.293003C9.48412 0.102001 9.74012 0 10.0001 0C10.1291 0 10.2591 0.0250005 10.3831 0.0760012C10.7561 0.231003 11.0001 0.596008 11.0001 1.00001V19.0002C11.0001 19.4042 10.7561 19.7693 10.3831 19.9243Z"
        />
    </svg>
</template>

<script setup></script>

<style lang="scss" scoped></style>
